'use strict';

var React = require('react');

var SvgPackageMajor = function SvgPackageMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 5h-8v-3h5.227c.382-.001.736.162.928.429l1.845 2.571zm-15.227-3h5.227v3h-8l1.845-2.571c.192-.267.546-.43.928-.429zm-2.773 5v10.5a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-10.5h-18zm2 2h6v4h-6v-4z"
  }));
};

exports.SvgPackageMajor = SvgPackageMajor;
